import { connect } from 'react-redux';
import { doFreshSearch, loadMoreResults } from '../../common/actions/Search';
import StaticSearch from '../components/StaticSearch';
function mapStateToProps(state) {
  return {
    search: state.get('search')
  };
}
function mapDispatchToProps(dispatch, ownProps) {
  return {
    doFreshSearch(_ref) {
      let {
        filters,
        resolveAlgoliaQueryFilterOverrides,
        featureFlags
      } = _ref;
      dispatch(doFreshSearch({
        algoliaClient: ownProps.algoliaClient,
        applyOverrides: ownProps.applyOverrides,
        environment: ownProps.environment,
        filters,
        resolveAlgoliaQueryFilterOverrides,
        featureFlags
      }));
    },
    onLoadMoreResultsClick(_ref2) {
      let {
        currentPage,
        featureFlags
      } = _ref2;
      if (ownProps.onLoadMoreResultsClick) {
        ownProps.onLoadMoreResultsClick({
          currentPage
        });
      }
      dispatch(loadMoreResults({
        algoliaClient: ownProps.algoliaClient,
        applyOverrides: ownProps.applyOverrides,
        environment: ownProps.environment,
        filters: ownProps.filters,
        nextPage: currentPage + 1,
        resolveAlgoliaQueryFilterOverrides: ownProps.resolveAlgoliaQueryFilterOverrides,
        featureFlags
      }));
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(StaticSearch);